import { Theme } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React from 'react'

interface IHeaderProps {
  icon: React.ElementType
  title: string
}

function useStyles() {
  return makeStyles((theme: Theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '0px',
      marginBottom: theme.spacing(2),
      paddingLeft: theme.spacing(3),
    },
    title: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '8px',
    },
    text: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '24px',
      lineHeight: '29px',
      letterSpacing: '0.15px',
    },
    icon: {
      fontSize: 24,
    },
  }))()
}

export default function Header({ children, title, icon: Icon }: React.PropsWithChildren<IHeaderProps>) {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Box className={classes.title}>
        <Icon className={classes.icon} />
        <Typography className={classes.text}>{title}</Typography>
      </Box>
      {children}
    </Box>
  )
}
